import { useDeleteUnitApi } from '../api/delete-unit-api'
import { useEffect } from 'react'
import { notification } from '@/shared/helpers/notificationMessages'
import { errorHandler } from '@/shared/lib/errorHandler'
import { useTranslation } from 'react-i18next'

export const useDeleteUnit = () => {
  const { mutateAsync, isPending: isLoadingDelete, isSuccess: isSuccessDelete } = useDeleteUnitApi()
  const { t } = useTranslation(['common'])

  const handleDeleteUnit = async (id: number, onClose: () => void) => {
    try {
      await mutateAsync(id)
    } catch (error) {
      errorHandler(error, t('common:notification_messages.delete_unit_error'))
    } finally {
      onClose()
    }
  }

  useEffect(() => {
    if (isSuccessDelete) {
      notification.success(
        t('common:notification_titles.success'),
        t('common:notification_messages.delete_unit_success'),
      )
    }
  }, [isSuccessDelete])

  return {
    isLoadingDelete,
    handleDeleteUnit,
  }
}
